import {Component, OnInit, Injector, ElementRef, ViewChild, Output, EventEmitter, Input} from '@angular/core';
import {AppComponentBase} from '../../../services/AppComponentBase';
import {ScannerPrimarySearchList, ScannerSideListItems, ScannerChartingStudy, ScannerSide, getSideName, getStudyName} from '../interfaces/scanner.enums';
import {filter} from 'rxjs/operators';
import {ICHWizardResultRow, IESResultRow, IRsiResultRow, IBBResultRow, IMacdResultRow, IEmaResultRow, ITIWizardResultRow} from '../model/scanData';
import {BoxQuotaData} from '../../../model/box.quote.data';
import * as moment from "moment";
import * as $ from "jquery";
import "malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js";

import {quoteFilterTabsParams} from '../../quoteFilterTabs/quoteFilterTabs.list';
import {IchWizardpointType, IRSIScanRule, IBBandsScanRule, IEMAScanRule, IMACDScanRule, IEntrySignalsScanData, ScanHistory} from '../interfaces/scanner.interfaces';
import {ShowsaveScanComponentModal} from '../../modals/saveScan/saveScan.component';
import {showScannerTrialPopupModal} from '../modals/ScannerTrialPopup/show-ScannerTrialPopup-modal';
import {showScannerTrialReminderModal} from '../modals/ScannerTrialReminder/show-ScannerTrialReminder-modal';
import {showScannerTrialInfoImagesModal} from '../modals/ScannerTrialInfoImages/show-ScannerTrialInfoImages-modal';
import {showScannerAutoTrialModal} from '../modals/ScannerAutoTrial/show-ScannerAutoTrial-modal';
import {HistoryItemPeriod, getPeriodName} from '../../../interfaces/historyItem';
import {ScannerResultsComponent} from '../scanner-Results/scanner-Results.component';
import {showScannerTrialPopuMobileModal} from '../modals/ScannerTrialPopupMobile/show-ScannerTrialPopupMobile-modal';
@Component({
    selector: 'app-mobile-scanner-Results',
    template: require('./mobile-scanner-Results.component.html'),
    styles: [require('./mobile-scanner-Results.component.scss')]
})
export class MobileScannerResultsComponent extends ScannerResultsComponent implements OnInit {

    constructor(injector: Injector) {
        super(injector);

    }

    public get isHorizontal()
    {
       return this.workspace.horizontalMode;
    }



    public jumpToActivate() {

        if(this.workspace.trialDaysToEnd <= 0 && this.workspace.trialDateRanges != undefined) {

            if(!this.hasSomeProduct) {
                showScannerTrialReminderModal(this.modalService, this.workspace.mobileMode);
            }
            else {
                showScannerTrialReminderModal(this.modalService, this.workspace.mobileMode);
            }

            return;
        }



        if(!this.workspace.allowScannerAccess && this.workspace.allowScannerTrial) {

            if(this.dataService.AllowScannerMobile)
            showScannerTrialPopuMobileModal(this.modalService, this.workspace, this.workspace.mobileMode);
            
        }

    }


    public showTrialInfoNow()
   {
       showScannerTrialInfoImagesModal(this.modalService, this.workspace.mobileMode,true);
   }
   

   public buyNow()
    {
        showScannerTrialReminderModal(this.modalService, this.workspace.mobileMode).modalType = "narrowScanner";
    }
    

    public folderState()
    {
       // this.globaGridMode.setFolderState()
       this.globaGridMode.setScannerMobileConfigVisibility.next(true);
    }
}


